import React from 'react';
import PropTypes from 'prop-types';
import { SecondaryButton, Text } from 'components';
import { push } from 'router/actions';
import { useDispatch } from 'react-redux';
import { getWatchId, getWatchLocation } from 'utils/helpers';

function EpisodeButton({ viewable }) {
  const dispatch = useDispatch();

  const onClick = () => {
    dispatch(push(getWatchLocation(getWatchId(viewable))));
  };

  return (
    <SecondaryButton
      variant="white"
      onClick={onClick}
      minWidth="auto"
      fullWidth
      sm-fullWidth={false}
      data-cy="episode-button"
    >
      <Text id="seeAllEpisodes" />
    </SecondaryButton>
  );
}

EpisodeButton.propTypes = {
  viewable: PropTypes.object,
};
export default React.memo(EpisodeButton);
